document.addEventListener('alpine:init', () => {
  Alpine.data('mmoQuiz', () => ({
    step: 'intro',
    questionIndex: 0,
    answers: {},

    QUESTIONS: [
      {
        id: 'occasion',
        text: 'What’s the occasion?',
        options: ['Wedding', 'Festive', 'Casual', 'Formal']
      },
      {
        id: 'style',
        text: 'Which style feels most like you?',
        options: ['Minimal', 'Bold', 'Traditional', 'Trendy']
      },
      {
        id: 'color',
        text: 'What color palette are you wearing?',
        options: ['Gold tones', 'Silver tones', 'Mixed', 'Not sure']
      }
    ],

    init() {
      console.log('[MMO] Quiz initialized');
    },

    get currentQuestion() {
      return this.QUESTIONS[this.questionIndex];
    },

    get progress() {
      return `${this.questionIndex + 1} / ${this.QUESTIONS.length}`;
    },

    startQuiz() {
      this.step = 'quiz';
      this.questionIndex = 0;
      this.answers = {};
    },

    startUpload() {
      this.step = 'complete';
      // upload flow will be wired later
    },

    selectOption(option) {
      const q = this.currentQuestion;
      this.answers[q.id] = option;

      if (this.questionIndex < this.QUESTIONS.length - 1) {
        this.questionIndex++;
      } else {
        this.completeQuiz();
      }
    },

    completeQuiz() {
      this.step = 'complete';
      console.log('[MMO] Answers:', this.answers);
    }
  }));
});
